import { render } from "./responsibility.vue?vue&type=template&id=21ecdb5a&scoped=true"
import script from "./responsibility.vue?vue&type=script&lang=js"
export * from "./responsibility.vue?vue&type=script&lang=js"

import "./responsibility.vue?vue&type=style&index=0&id=21ecdb5a&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ecdb5a"]])

export default __exports__